<template>
  <div>
    <template v-if="$route.name !== 'login'">
      <div id="wrapper" v-show="loaded">
        <nav-bar-component></nav-bar-component>
        <div id="content_wrap">
          <router-view v-if="loaded"></router-view>
        </div>
      </div>
    </template>

    <router-view v-else></router-view>
  </div>
</template>

<script>
import NavBarComponent from './components/shared/NavBarComponent';
export default {
  components: {NavBarComponent},
  name: 'App',
  data() {
    return {
      loaded: false
    }
  },
  async created() {
    await this.axios('/user')
      .then(()=>{
        this.$store.dispatch('auth/getUserPermissions')
      })
      .catch(() => {
        this.$store.dispatch('auth/logout');
        this.$router.push({name: 'login'});
      })
      .finally(() => this.loaded = true)

    await this.axios('/pages/types').then((response)=>{
      this.$store.commit('setPagesType', response.data.data)
    })

  },
  mounted() {
    this.collapseArrow();
  }
}
</script>